import { Component, OnInit , ViewChild } from '@angular/core';
import {Grid , GridSearchItem , ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ServiceSubjectService} from '../../../Services//service-subject.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-archive-service-subject',
  templateUrl: './archive-service-subject.component.html',
  styleUrls: ['./archive-service-subject.component.scss']
})
export class ArchiveServiceSubjectComponent implements OnInit {

  public grid: Grid;
  public serviceSubjectId;
  public serviceSubjectName;
  @ViewChild('readdModal', {static: false}) readdModal = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    private translateService: TranslateService,
    private broadcastService: BroadcastService,
    private serviceSubjectService: ServiceSubjectService
  ) { }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.service_subject.subject',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          
        },
        <TextColumn>{
          name: 'doctrine.service_subject.solution',
          prop: 'solutions',
          type: TextColumn.type,
          sortable: true,
          translate: true,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-plus fa-lg',
              tooltip: 'global.readd',
              onclick: row => {
                this.serviceSubjectId = row.id;
                this.serviceSubjectName = row.name.bold();
                this.readdModal.show();
              },
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.serviceSubjectService,
      rememberURL: this.router.url,
      method: 'getArchiveServiceSubjects',
      defaultSort: 'position',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
    };
  }

  public readdServiceSubject() {
    this.serviceSubjectService.readdServiceSubject(this.serviceSubjectId).subscribe((res) => {
      this.readdModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getArchiveServiceSubjects');
    });
  }

  goToOverview() {
    this.router.navigateByUrl('back-office/service/subject/overview');
  }

}
